const theme = {
    colors: {
        white: "#ffffff",
        nearBlack: "#202124",
        lightGray: "#f8f9fa",
        gray: "#e1e1e1",
        darkGray: "#616161",
        lighterPurple: "#eee9f8",
        lightPurple: "#9f7fd9",
        purple: "#4100b3",
        darkPurple: "#33008c",
        neonGreen: "#ccff00",
        darkNeonGreen: "#bceb00",
        red: "#ff3131",
    },
};
export default theme;
